export const cmsContentPath: string = 'cms-content';